import { render, staticRenderFns } from "./SubscriptionOverviewPickUp.vue?vue&type=template&id=1165d31a&scoped=true&"
import script from "./SubscriptionOverviewPickUp.vue?vue&type=script&lang=js&"
export * from "./SubscriptionOverviewPickUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1165d31a",
  null
  
)

export default component.exports